"use client";

import { Activity, ArrowRight, Baby, HeartPulse, Microscope, ShieldCheck, Stethoscope } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  icon: Stethoscope,
  title: "Genel Hukuk Danışmanlığı",
  description: "Bireysel ve kurumsal ihtiyaçlarınız için günlük hukuki süreçlerde profesyonel rehberlik ve stratejik destek."
}, {
  icon: Baby,
  title: "Aile ve Miras Hukuku",
  description: "Boşanma, velayet ve miras paylaşımı gibi hassas konularda haklarınızı koruyan, çözüm odaklı yaklaşım."
}, {
  icon: HeartPulse,
  title: "Ticaret ve Şirketler",
  description: "Şirket kuruluşu, sözleşme yönetimi ve ticari uyuşmazlıklarda işletmenizin geleceğini güvence altına alıyoruz."
}, {
  icon: Activity,
  title: "İş ve Sosyal Güvenlik",
  description: "İşçi ve işveren arasındaki uyuşmazlıklar, tazminat hakları ve yasal uyum süreçlerinde uzman savunma."
}, {
  icon: ShieldCheck,
  title: "Ceza Hukuku Savunması",
  description: "Soruşturma ve kovuşturma aşamalarında adil yargılanma hakkınızı savunan kararlı ve titiz hukuki temsil."
}, {
  icon: Microscope,
  title: "Gayrimenkul ve İnşaat",
  description: "Tapu iptal tescil, kiralama ve inşaat projelerindeki hukuki risklerin analizi ve yönetimi konusunda uzmanlık."
}];
function ServiceCard({
  service,
  index
}: {
  service: typeof services[number];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const Icon = service.icon;
  return <div ref={ref} data-index={index} style={{
    transitionDelay: `${index * 80}ms`
  }} className={`group relative flex flex-col rounded-lg border border-border bg-card p-8 sm:p-10 transition-all duration-700 ease-out hover:-translate-y-1 hover:shadow-xl ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <div className="mb-8">
        <div className="flex h-[88px] w-[88px] items-center justify-center rounded-lg bg-accent/10 transition-colors duration-500 group-hover:bg-accent">
          <Icon className="h-[44px] w-[44px] text-accent transition-colors duration-500 group-hover:text-accent-foreground" strokeWidth={1.25} />
        </div>
      </div>

      <h3 className="font-default text-2xl font-semibold text-foreground mb-3">
        {service.title}
      </h3>

      <p className="font-default text-[15px] leading-relaxed text-muted-foreground mb-8 flex-1">
        {service.description}
      </p>

      <Link to="/ServicesPage" className="inline-flex items-center gap-2 text-sm font-medium text-accent hover:text-foreground transition-colors duration-300">
        <span>Detayları incele</span>
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
    </div>;
}
export default function Petitioncategories() {
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="668" id="petitioncategories" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={introRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 md:mb-20 lg:mb-24 transition-all duration-700 ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-6 flex flex-col">
            <span className="font-default text-xs tracking-[0.2em] uppercase text-accent mb-6">
              Uzmanlık Alanlarımız
            </span>
            <h2 className="font-default text-4xl sm:text-5xl lg:text-[56px] leading-[1.1] font-bold text-foreground tracking-tight">
              Hukukun her alanında güvenilir rehberlik.
            </h2>
            <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground mt-8 max-w-xl">
              Karmaşık yasal süreçlerde yanınızdayız. Bireysel haklarınızdan kurumsal stratejilerinize kadar her adımda profesyonel ve etik bir yaklaşımla savunmanızı üstleniyoruz.
            </p>
          </div>

          <div className="lg:col-span-6 lg:pt-24">
            <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl">
              Hukuk büromuzda, adaletin sadece bir sonuç değil, bir süreç olduğuna inanıyoruz. Müvekkillerimizle kurduğumuz şeffaf iletişim ve titiz çalışma prensibimizle, her vakayı kendi özel şartları içinde değerlendirerek en etkili çözümleri üretiyoruz.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => <ServiceCard key={service.title} service={service} index={i} />)}
        </div>

        {}
        <div className="mt-16 md:mt-20 flex justify-center">
          <Link to="/ServicesPage" className="group inline-flex items-center gap-2 font-default text-sm tracking-wide text-accent hover:text-foreground transition-colors duration-300">
            <span className="border-b border-accent/30 group-hover:border-foreground/50 pb-1 transition-colors duration-300">
              Tüm hizmetleri ve uzmanlıkları görüntüle
            </span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>;
}